<template>
  <div class="white text-body-2 black--text mt-3 mb-3 pt-4 pb-4 pl-4 pr-4 rounded-lg"
    :class="{ 'no-paid': !item.paid }">
    <!-- Desktop layout -->
    <div class="d-none d-md-flex align-center">
      <div class="info--number font-weight-bold text-truncate">
        {{ item._id.slice(-5) }}
      </div>
      <div class="info--name text-truncate text-uppercase pr-2">
        {{ item.name }}
      </div>
      <div class="info--phone">{{ item.movilNumber }}</div>
      <div class="info--address text-uppercase text-truncate">
        {{ item.address }}
      </div>
      <div class="info--actions d-flex justify-center">
        <v-btn v-if="registerPayment" class="mr-1" depressed outlined text small color="primary" @click="$emit('detail', item._id)">
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn v-if="showEdit" class="mr-1" depressed outlined text small color="primary" @click="$emit('edit', item._id)">
          <v-icon small>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn v-if="showDelete" depressed outlined text small color="primary" @click="$emit('delete', item)">
          <v-icon small>mdi-delete-empty-outline</v-icon>
        </v-btn>
      </div>
    </div>
    <!-- Mobile layout -->
    <div class="d-flex d-md-none flex-column">
      <div class="d-flex justify-space-between align-center mb-2">
        <span class="font-weight-bold primary--text mr-2">{{ item._id.slice(-5) }}</span>
        <div>
          <v-btn v-if="registerPayment" icon small color="primary" @click="$emit('detail', item._id)">
            <v-icon small>mdi-eye</v-icon>
          </v-btn>
          <v-btn v-if="showEdit" icon small color="primary" @click="$emit('edit', item._id)">
            <v-icon small>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn v-if="showDelete" icon small color="primary" @click="$emit('delete', item)">
            <v-icon small>mdi-delete-empty-outline</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="text-uppercase font-weight-medium mb-1">{{ item.name }}</div>
      <div class="text-caption grey--text">
        <v-icon x-small class="mr-1">mdi-phone</v-icon>{{ item.movilNumber }}
        <span class="ml-2"><v-icon x-small class="mr-1">mdi-map-marker</v-icon>{{ item.address }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "../../../common/EventBus";

export default {
  name: "ClientTemporalTableItem",
  mounted() {
    var localData = JSON.parse(localStorage.LCInternet);
    this.showDelete = localData.user.rol === "admin";
    this.showEdit = true;
    this.registerPayment = true;
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      showDelete: false,
      showEdit: false,
      registerPayment: false
    };
  },
  methods: {
    prueba: function(id) {
      Bus.$emit("prueba", id);
    }
  }
};
</script>

<style lang="scss" scoped>
.no-paid {
  border: 1px solid rgb(224, 173, 173) !important;
  background-color: rgb(255, 240, 240) !important;
}
</style>
